import React from 'react';
import { MessageContentWrapper } from './MessageContentWrapper';

export const DisplayText = ({ text }: { text: string }) => {
    return (
        <MessageContentWrapper>
            <div className='border-subtle bg-neutral-subtle rounded-lg border p-3 shadow-sm'>
                <div className='flex items-center gap-2'>
                    <div className='bg-neutral-main size-2 animate-pulse rounded-full' />
                    <span className='caption-1-bold text-gray'>Loading...</span>
                </div>
                <p className='caption-1-regular text-gray mt-2'>{text}</p>
            </div>
        </MessageContentWrapper>
    );
};
